export function startAnimationAfterDelay(element, delay) {
    setTimeout(function() {
        element.classList.add("slideInViewport");
    }, delay);
}